// DriverDetailModal.jsx
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Avatar } from 'primereact/avatar';
import { Tag } from 'primereact/tag';
// No necesitamos Chip ni Divider para la sección de imágenes eliminada, así que los quito si no se usan en otro lado.
// import { Chip } from 'primereact/chip';
// import { Divider } from 'primereact/divider'; 

// Iconos de react-icons/fa
import {
    FaUser, FaIdCard, FaMapMarkerAlt, FaPhone, FaEnvelope,
    FaBirthdayCake, FaBriefcase, FaGraduationCap, FaRulerCombined,
    FaMars, FaCalendarAlt, FaStar, FaInfoCircle, FaCar, FaClock,
    FaCheckCircle, FaTimesCircle, FaMoneyBillAlt, FaTruck,
    FaHeartbeat, FaWeight, FaTint, FaDumbbell, FaSmoking, FaWineGlassAlt, // Nuevos iconos para salud
    FaExclamationTriangle, FaClinicMedical, FaBandAid // Iconos para emergencias/salud
} from 'react-icons/fa';

import './DriverDetailModal.scss'; // SCSS específico para el modal
import { getInfoOperador } from '../MaestroDeServiciosIntegracion';
import { Tooltip } from '@mui/material';

// Datos de ejemplo para simular la API
// *** CAMBIO CLAVE AQUÍ: mockDriverDetails ahora es un ARRAY de objetos ***
// const mockDriverDetails = [
//     {
//         ID: 319, // El ID ahora es una propiedad dentro del objeto
//         NOMBRE: "ADAN ARIAS SOTELO",
//         DIRECCION: "AV. SIEMPRE VIVA 742",
//         COLONIA: "JARDINES DEL ALBA",
//         REFERENCIA: "FRENTE AL PARQUE",
//         MUNICIPIO: "ZAPOPAN",
//         ESTADO: "JALISCO",
//         TELEFONO: "3398765432",
//         CELULAR_SUMA: "3354321098",
//         TELEFONO_ESPOSA: "3376543210",
//         CELULAR_PARTICULAR: "3301234567",
//         F_NACIMIENTO: "15/05/1980",
//         AFILIACION_IMSS: "12345678901",
//         FECHA_INGRESO: "01/03/2018",
//         RFC: "ADAN800515XYZ",
//         TALLA_PANTALON: "34",
//         TALLA_CAMISA: "L",
//         SEXO: "MASCULINO",
//         ESTADO_CIVIL: "SOLTERO",
//         ESCOLARIDAD: "LICENCIATURA",
//         LATITUD: "20.675",
//         LONGITUD: "-103.345",
//         USUARIO: "adan.arias@example.com",
//         DIA_DESCANSO: "SABADO",
//         PUESTO: "OPERADOR",
//         ID_PUESTO: 475,
//         IMAGEN_URL: "https://via.placeholder.com/150/FF0000/FFFFFF?text=Adan",
//         ACTIVO: false,
//         SALARIO_MENSUAL: '30000.00',
//         NUM_NOMINA: 'OPR-00456',
//         UNIDAD: 'Caja Seca 40ft',

//         NUM_LICENCIA: 'E987654321098',
//         TIPO_LICENCIA: 'Tipo C Estatal',
//         FECHA_VENCIMIENTO_LICENCIA: '15/07/2026',
//         UNIDAD_ASIGNADA_LICENCIA: '319 SPRINTER',
//         MED_PREVENTIVA: '987654',
//         VIG_APTO_MEDICO: '01/01/2027',

//         ALTURA: '1.75',
//         PESO: '85',
//         TENSION_ARTERIAL: '130/85',
//         FRECUENCIA_CARDIACA: '80',
//         TIPO_SANGRE: 'A+',
//         GLICEMIA_CAPILAR: '110',
//         CONSUME_ALCOHOL: true,
//         FUMA: true,
//         INTERVENCIONES_QUIRURGICAS: false,
//         TIPO_INTERVENCIONES: 'Ninguna',
//         CONSUME_DROGAS: false,
//         TIPO_DROGAS: 'Ninguna',

//         NOMBRE_EMERGENCIA: 'CARLA RAMIREZ (HERMANA)',
//         TELEFONO_EMERGENCIA: '3311223344',
//         TIPO_SANGRE_EMERGENCIA: 'A+',

//         IMAGEN_PERFIL: 'http://googleusercontent.com/file_content/48',
//     },
// ];
const DriverDetailModal = ({ idOperator, visible, onHide }) => {
    const [driverDetails, setDriverDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    console.log(driverDetails);


    useEffect(() => {
        if (visible && idOperator) {
            getInfoOperador(setDriverDetails, idOperator, setLoading)

           
        } else if (!visible) {
            setDriverDetails(null);
        }
    }, [visible, idOperator]);
   
    const header = (
        <div className="driver-modal-header">
            <Tooltip title={<img src={driverDetails?.FOTOGRAFIA} alt="" />}>
                <div>
                    <Avatar image={driverDetails?.FOTOGRAFIA} icon="pi pi-user" shape="circle" className="driver-avatar" />
                </div>
            </Tooltip>
            <div className="driver-header-info">
                <h2 className="driver-name">{driverDetails?.NOMBRE || 'Cargando...'}</h2>
                <span className="driver-id">ID: {idOperator || '-'}</span>
                {driverDetails?.PUESTO && <span className="driver-position">{driverDetails.PUESTO}</span>}
            </div>
            {driverDetails && (
                <div className="driver-status">
                    {driverDetails.ACTIVO ? (
                        <Tag value="Activo" severity="success" icon="pi pi-check-circle" />
                    ) : (
                        <Tag value="Inactivo" severity="danger" icon="pi pi-times-circle" />
                    )}
                </div>
            )}
        </div>
    );

    const renderDetailCard = (title, icon, fields) => (
        <div className="detail-card">
            <div className="detail-card-header">
                {React.cloneElement(icon, { className: "detail-card-icon" })}
                <h3>{title}</h3>
            </div>
            <div className="detail-card-content">
                {fields.map((field, index) => (
                    <div className="detail-item" key={index}>
                        {field.icon && React.cloneElement(field.icon, { className: "detail-item-icon" })}
                        <span><strong>{field.label}:</strong> {field.value}</span>
                    </div>
                ))}
            </div>
        </div>
    );

    // renderImageCard se mantiene como helper, pero ya no se llama en el render principal
    // const renderImageCard = (title, images) => (...)


    return (
        <Dialog
            header={header}
            visible={visible}
            style={{ width: '65vw' }}
            breakpoints={{ '1200px': '75vw', '960px': '90vw', '641px': '100vw' }}
            onHide={() => { onHide() }}
            modal
            draggable={false}
            resizable={false}
            closeOnEscape
            className='DriverDetailModal'
        >
            {loading ? (
                <div className="modal-loading-container">
                    <ProgressSpinner />
                    <p className="loading-text">Cargando detalles del operador...</p>
                </div>
            ) : driverDetails ? (
                <div className="driver-details-content">
                    <div className="driver-details-grid">
                        {renderDetailCard("Información Personal", <FaUser />, [
                            { label: "RFC", value: driverDetails.RFC || '-', icon: <FaIdCard /> },
                            { label: "Nacimiento", value: driverDetails.FECHA_NACIMIENTO || '-', icon: <FaBirthdayCake /> },
                            { label: "Sexo", value: driverDetails.SEXO==1?'MASCULINO':'FEMENINO' || '-', icon: <FaMars /> },
                            { label: "Estado Civil", value: driverDetails.ESTADO_CIVIL || '-', icon: <FaStar /> },
                            { label: "Escolaridad", value: driverDetails.ESCOLARIDAD || '-', icon: <FaGraduationCap /> }
                        ])}

                        {renderDetailCard("Información de Contacto", <FaPhone />, [
                            { label: "Teléfono", value: driverDetails.TELEFONO || '-', icon: <FaPhone /> },
                            { label: "Cel. Empresa", value: driverDetails.CELULAR_EMPRESA || '-', icon: <FaPhone /> },
                            { label: "Cel. Particular", value: driverDetails.CELULAR_PARTICULAR || '-', icon: <FaPhone /> },
                            { label: "Tel. Esposa", value: driverDetails.TEL_ESPOSA || '-', icon: <FaPhone /> },
                            { label: "Usuario (Email)", value: driverDetails.EMAIL || '-', icon: <FaEnvelope /> }
                        ])}

                        {renderDetailCard("Ubicación", <FaMapMarkerAlt />, [
                            { label: "Dirección", value: driverDetails.DIRECCION || '-', icon: <FaMapMarkerAlt /> },
                            { label: "Colonia", value: driverDetails.COLONIA || '-', icon: <FaMapMarkerAlt /> },
                            { label: "Municipio", value: driverDetails.MUNICIPIO || '-', icon: <FaMapMarkerAlt /> },
                            { label: "Estado", value: driverDetails.ESTADO || '-', icon: <FaMapMarkerAlt /> },
                            { label: "Referencia", value: driverDetails.REFERENCIA || '-', icon: <FaInfoCircle /> },
                            {
                                label: "Mapa",
                                value: (driverDetails.LATITUD && driverDetails.LONGITUD) ?
                                    <a href={`http://maps.google.com/?q=${driverDetails.LATITUD},${driverDetails.LONGITUD}`} target="_blank" rel="noopener noreferrer" className="map-link">Ver en Mapa</a>
                                    : '- SIN LATITUD O LONGITUD',
                                icon: <FaMapMarkerAlt />
                            }
                        ])}

                        {renderDetailCard("Información Laboral", <FaBriefcase />, [
                            { label: "Puesto", value: driverDetails.PUESTO || '-', icon: <FaBriefcase /> },
                            { label: "Fecha Ingreso", value: driverDetails.INGRESO || '-', icon: <FaCalendarAlt /> },
                            { label: "Día Descanso", value: driverDetails.DIA_DESCANSO?driverDetails.DIA_DESCANSO:"NUNGUNO" || '-', icon: <FaClock /> },
                            // { label: "Salario Mensual", value: driverDetails.SALARIO_MENSUAL ? `$${parseFloat(driverDetails.SALARIO_MENSUAL).toLocaleString('es-MX', { minimumFractionDigits: 2 })}` : '-', icon: <FaMoneyBillAlt /> },
                            // { label: "Num. Nómina", value: driverDetails.NUM_NOMINA || '-', icon: <FaIdCard /> },
                            { label: "Unidad Asignada", value: driverDetails.ID_UNIDAD || 'N/A', icon: <FaCar /> },
                            { label: "Talla Camisa", value: driverDetails.TALLA_CAMISA || '-', icon: <FaRulerCombined /> },
                            { label: "Talla Pantalón", value: driverDetails.TALLA_PANTALON || '-', icon: <FaRulerCombined /> },
                            {
                                label: "Estatus", value: driverDetails.ACTIVO ? <span className="status-active">Activo</span> : <span className="status-inactive">Inactivo</span>,
                                icon: driverDetails.ACTIVO ? <FaCheckCircle className="status-active" /> : <FaTimesCircle className="status-inactive" />
                            }
                        ])}

                        {/* Sección: Información de Licencia */}
                        {renderDetailCard("Información de Licencia", <FaIdCard />, [
                            { label: "Licencia", value: driverDetails.NUMERO_LICENCIA || '-', icon: <FaIdCard /> },
                            { label: "Vencimiento", value: driverDetails.VENCIMIENTO_LICENCIA || '-', icon: <FaCalendarAlt /> },
                            { label: "Tipo Licencia", value: driverDetails.TIPO_LICENCIA || '-', icon: <FaIdCard /> },
                            { label: "Unidad Asignada", value: driverDetails.ID_UNIDAD + ' - '+driverDetails.TIPO_UNIDAD || 'N/A', icon: <FaCar /> },
                            { label: "Med. Preventiva", value: driverDetails.MEDIDA_PREVENTIVA || '-', icon: <FaClinicMedical /> },
                            { label: "Vig. Apto Médico", value: driverDetails.APTO_MEDICO || '-', icon: <FaCheckCircle /> }
                        ])}

                        {/* Sección: Datos de Salud */}
                        {renderDetailCard("Datos de Salud", <FaHeartbeat />, [
                            { label: "Altura", value: `${driverDetails.ALTURA || '-'} m`, icon: <FaRulerCombined /> },
                            { label: "Peso", value: `${driverDetails.PESO || '-'} kg`, icon: <FaWeight /> },
                            { label: "Tensión Arterial", value: driverDetails.TENSION_ARTERIAL || '-', icon: <FaDumbbell /> },
                            { label: "Frec. Cardíaca", value: `${driverDetails.FRECUENCIA_CARDIACA || '-'} bpm`, icon: <FaHeartbeat /> },
                            { label: "Tipo Sangre", value: driverDetails.TIPO_SANGRE || '-', icon: <FaTint /> },
                            { label: "Glicemia Capilar", value: `${driverDetails.GLICEMIA_CAPILAR || '-'} mg/dL`, icon: <FaBandAid /> },
                            { label: "Consume Alcohol", value: driverDetails.CONSUME_ALCOHOL ? 'Sí' : 'No', icon: <FaWineGlassAlt /> },
                            { label: "Fuma", value: driverDetails.FUMA ? 'Sí' : 'No', icon: <FaSmoking /> },
                            { label: "Intervenciones Q.", value: driverDetails.INTERVERCIONES_QUIRURJICAS ? 'Sí' : 'No', icon: <FaClinicMedical /> },
                            { label: "Tipo Interv.", value: driverDetails.TIPO_INTERVERCIONES_QUIRURJICA || 'Ninguna', icon: <FaInfoCircle /> },
                            { label: "Consume Drogas", value: driverDetails.CONSUME_DROGAS ? 'Sí' : 'No', icon: <FaExclamationTriangle /> },
                            { label: "Tipo Drogas", value: driverDetails.TIPO_CONSUMO_DROGAS || '', icon: <FaInfoCircle /> }
                        ])}

                        {/* Sección: Datos de Emergencia */}
                        {renderDetailCard("Datos de Emergencia", <FaExclamationTriangle />, [
                            { label: "Nombre", value: driverDetails.CONTACTO_NOMBRE || '-', icon: <FaUser /> },
                            { label: "Teléfono", value: driverDetails.CONTACTO_TELEFONO || '-', icon: <FaPhone /> },
                            { label: "Tipo Sangre", value: driverDetails.TIPO_SANGRE_EMERGENCIA || '-', icon: <FaTint /> }
                        ])}

                    </div>
                </div>
            ) : (
                <div className="modal-no-data-container">
                    <p>No se encontraron detalles para este operador.</p>
                </div>
            )}
        </Dialog>
    );
};

export default DriverDetailModal;